import {
  Button,
  Field,
  FieldDescription,
  FieldError,
  FieldGroup,
  FieldLabel,
  Input,
} from "@base/ui";
import { useState, type FormEvent } from "react";
import { mensagemDoErro } from "../../../shared/http/mensagem-de-erro";

/** Formulario do cliente (so o nome, por enquanto). Serve para criar e renomear. */
export function FormularioDeCliente({
  nomeInicial = "",
  rotuloDoBotao,
  enviando,
  erro,
  aoEnviar,
}: {
  readonly nomeInicial?: string;
  readonly rotuloDoBotao: string;
  readonly enviando: boolean;
  readonly erro: unknown;
  readonly aoEnviar: (nome: string) => void;
}) {
  const [nome, setNome] = useState(nomeInicial);
  const valido = nome.trim().length >= 2;

  function enviar(evento: FormEvent<HTMLFormElement>) {
    evento.preventDefault();
    if (valido) aoEnviar(nome.trim());
  }

  return (
    <form onSubmit={enviar} noValidate className="flex flex-col gap-6">
      <FieldGroup>
        <Field>
          <FieldLabel htmlFor="nome-do-cliente">Nome da clínica</FieldLabel>
          <Input
            id="nome-do-cliente"
            autoComplete="off"
            value={nome}
            onChange={(evento) => setNome(evento.target.value)}
            required
          />
          <FieldDescription>É o nome que aparece no seletor da barra lateral.</FieldDescription>
        </Field>
        {erro ? <FieldError>{mensagemDoErro(erro)}</FieldError> : null}
        <Button type="submit" disabled={enviando || !valido}>
          {enviando ? "Salvando…" : rotuloDoBotao}
        </Button>
      </FieldGroup>
    </form>
  );
}
